// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CeliSelectionOverviewTabQueryVariables = Types.Exact<{
  filter: Types.ChangeEventLineItemFilter;
}>;


export type CeliSelectionOverviewTabQuery = { __typename?: 'Query', changeEventLineItems: Array<{ __typename?: 'ChangeEventLineItem', internalNote?: string | null | undefined, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, type: Types.ChangeEventLineItemType, id: string, name: string, changeEvent: { __typename?: 'ChangeEvent', id: string, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean } }, location: { __typename?: 'Location', id: string, name: string }, projectItem: { __typename?: 'ProjectItem', id: string, costType: Types.CostType, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined } } }>, locations: Array<{ __typename?: 'Location', id: string, name: string }> };

export type CeliSelectionOverviewTabSaveCeliMutationVariables = Types.Exact<{
  celi: Types.SaveChangeEventLineItemInput;
}>;


export type CeliSelectionOverviewTabSaveCeliMutation = { __typename?: 'Mutation', saveChangeEventLineItems: { __typename?: 'SaveChangeEventLineItemsResult', changeEventLineItems: Array<{ __typename?: 'ChangeEventLineItem', internalNote?: string | null | undefined, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, type: Types.ChangeEventLineItemType, id: string, name: string, changeEvent: { __typename?: 'ChangeEvent', id: string, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean } }, location: { __typename?: 'Location', id: string, name: string }, projectItem: { __typename?: 'ProjectItem', id: string, costType: Types.CostType, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined } } }> } };

export type CeliSelectionOverviewTabChangeEventLineItemsFragment = { __typename?: 'ChangeEventLineItem', internalNote?: string | null | undefined, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, type: Types.ChangeEventLineItemType, id: string, name: string, changeEvent: { __typename?: 'ChangeEvent', id: string, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean } }, location: { __typename?: 'Location', id: string, name: string }, projectItem: { __typename?: 'ProjectItem', id: string, costType: Types.CostType, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined } } };

export const CeliSelectionOverviewTabChangeEventLineItemsFragmentDoc = gql`
    fragment CeliSelectionOverviewTabChangeEventLineItems on ChangeEventLineItem {
  ...Named
  changeEvent {
    id
    canEditLineItems {
      allowed
    }
  }
  internalNote
  location {
    ...Named
  }
  projectItem {
    id
    costType
    item {
      id
      costCode {
        id
        displayName
      }
      tradeCategory {
        ...Named
      }
    }
  }
  specifications
  tradePartnerNote
  type
}
    ${NamedFragmentDoc}`;
export const CeliSelectionOverviewTabDocument = gql`
    query CeliSelectionOverviewTab($filter: ChangeEventLineItemFilter!) {
  changeEventLineItems(filter: $filter) {
    ...CeliSelectionOverviewTabChangeEventLineItems
  }
  locations {
    ...Named
  }
}
    ${CeliSelectionOverviewTabChangeEventLineItemsFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useCeliSelectionOverviewTabQuery__
 *
 * To run a query within a React component, call `useCeliSelectionOverviewTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCeliSelectionOverviewTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCeliSelectionOverviewTabQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCeliSelectionOverviewTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CeliSelectionOverviewTabQuery, CeliSelectionOverviewTabQueryVariables> & ({ variables: CeliSelectionOverviewTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CeliSelectionOverviewTabQuery, CeliSelectionOverviewTabQueryVariables>(CeliSelectionOverviewTabDocument, options);
      }
export function useCeliSelectionOverviewTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CeliSelectionOverviewTabQuery, CeliSelectionOverviewTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CeliSelectionOverviewTabQuery, CeliSelectionOverviewTabQueryVariables>(CeliSelectionOverviewTabDocument, options);
        }
// @ts-ignore
export function useCeliSelectionOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CeliSelectionOverviewTabQuery, CeliSelectionOverviewTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CeliSelectionOverviewTabQuery, CeliSelectionOverviewTabQueryVariables>;
export function useCeliSelectionOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CeliSelectionOverviewTabQuery, CeliSelectionOverviewTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CeliSelectionOverviewTabQuery | undefined, CeliSelectionOverviewTabQueryVariables>;
export function useCeliSelectionOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CeliSelectionOverviewTabQuery, CeliSelectionOverviewTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CeliSelectionOverviewTabQuery, CeliSelectionOverviewTabQueryVariables>(CeliSelectionOverviewTabDocument, options);
        }
export type CeliSelectionOverviewTabQueryHookResult = ReturnType<typeof useCeliSelectionOverviewTabQuery>;
export type CeliSelectionOverviewTabLazyQueryHookResult = ReturnType<typeof useCeliSelectionOverviewTabLazyQuery>;
export type CeliSelectionOverviewTabSuspenseQueryHookResult = ReturnType<typeof useCeliSelectionOverviewTabSuspenseQuery>;
export type CeliSelectionOverviewTabQueryResult = Apollo.QueryResult<CeliSelectionOverviewTabQuery, CeliSelectionOverviewTabQueryVariables>;
export const CeliSelectionOverviewTabSaveCeliDocument = gql`
    mutation CeliSelectionOverviewTabSaveCeli($celi: SaveChangeEventLineItemInput!) {
  saveChangeEventLineItems(input: {changeEventLineItems: [$celi]}) {
    changeEventLineItems {
      ...CeliSelectionOverviewTabChangeEventLineItems
    }
  }
}
    ${CeliSelectionOverviewTabChangeEventLineItemsFragmentDoc}`;
export type CeliSelectionOverviewTabSaveCeliMutationFn = Apollo.MutationFunction<CeliSelectionOverviewTabSaveCeliMutation, CeliSelectionOverviewTabSaveCeliMutationVariables>;

/**
 * __useCeliSelectionOverviewTabSaveCeliMutation__
 *
 * To run a mutation, you first call `useCeliSelectionOverviewTabSaveCeliMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCeliSelectionOverviewTabSaveCeliMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [celiSelectionOverviewTabSaveCeliMutation, { data, loading, error }] = useCeliSelectionOverviewTabSaveCeliMutation({
 *   variables: {
 *      celi: // value for 'celi'
 *   },
 * });
 */
export function useCeliSelectionOverviewTabSaveCeliMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CeliSelectionOverviewTabSaveCeliMutation, CeliSelectionOverviewTabSaveCeliMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CeliSelectionOverviewTabSaveCeliMutation, CeliSelectionOverviewTabSaveCeliMutationVariables>(CeliSelectionOverviewTabSaveCeliDocument, options);
      }
export type CeliSelectionOverviewTabSaveCeliMutationHookResult = ReturnType<typeof useCeliSelectionOverviewTabSaveCeliMutation>;
export type CeliSelectionOverviewTabSaveCeliMutationResult = Apollo.MutationResult<CeliSelectionOverviewTabSaveCeliMutation>;
export type CeliSelectionOverviewTabSaveCeliMutationOptions = Apollo.BaseMutationOptions<CeliSelectionOverviewTabSaveCeliMutation, CeliSelectionOverviewTabSaveCeliMutationVariables>;